import { render, staticRenderFns } from "./CopyPasteTableInput.vue?vue&type=template&id=1788553f&scoped=true"
import script from "./CopyPasteTableInput.vue?vue&type=script&lang=js"
export * from "./CopyPasteTableInput.vue?vue&type=script&lang=js"
import style0 from "./CopyPasteTableInput.vue?vue&type=style&index=0&id=1788553f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1788553f",
  null
  
)

export default component.exports